import storage from './storage';

type CxenseProperties = {
	id: string
	segments: Array<string>
	marketingSegments: Array<string>
}

const MAX_SEGMENT_COUNT = 200;

export function getCxenseProperties(): CxenseProperties | null {
	const id = storage.get('_cX_G'),
		segments = storage.getArray('cxSegments').slice(0, MAX_SEGMENT_COUNT),
		marketingSegments = storage.getArray('cxSegments_m').slice(0, MAX_SEGMENT_COUNT - segments.length);

	return {
		id,
		segments,
		marketingSegments
	};
}
